import { graphql } from 'react-relay';

/**
 * One crawl run with its per-agent breakdown (pv-frontend#163), for the drill-in.
 * `run` carries the same summary shape as the runs list; `sites` is the ordered
 * per-agent detail — disposition, the full counts, and any per-site error.
 */
export const crawlRunQuery = graphql`
    query crawlRunQuery($id: UUID!) {
        crawlRun(id: $id) {
            run {
                id
                trigger
                requestedByOperator
                scope
                siteId
                status
                requestedUtc
                startedUtc
                completedUtc
                sitesCrawled
                sitesPartiallyCrawled
                listingsAdded
                listingsUpdated
                listingsUnchanged
                listingsMissed
                listingsDelisted
                rejectsQueued
            }
            sites {
                siteId
                siteName
                disposition
                coverage
                coverageNote
                listingsAdded
                listingsUpdated
                listingsUnchanged
                urlsInSitemap
                rejectsQueued
                listingsMissed
                listingsDelisted
                error
                startedUtc
                completedUtc
            }
        }
    }
`;
